module.exports = __webpack_public_path__ + "static/media/huli_503.87ca53b6.jpg";